import { runLinkEnhancements, replaceYesterday } from "./@helpers/js/enhancements.js";


export default function ContentEnhancements(element, options = {}) {

    if (!element) {
        return;
    }

    const _element = element;

    runLinkEnhancements(_element);
    replaceYesterday(_element);

}